export default __webpack_public_path__ + "static/media/Sellhelp.18cb8264.png";